var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4 text-center text-muted"},[_vm._v(" Redirection vers la création d'achat… ")])
}
var staticRenderFns = []

export { render, staticRenderFns }